import { ArrowRightIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { locale } from "./i18n.ts";
import { LanguagePicker } from "./language-picker.tsx";
import { Wordmark } from "./ui.tsx";

// The pages outside the shell (docs/design-system.md §0.4h, plan M7 step 7j):
// sign-in, an agent's consent and an invitation, in the website's layout. A
// light measuring grid, the wordmark top left linking to the website, one
// card in the middle, the language in the footer.

const WEBSITE = { "en-US": "https://zooi.ai/", "zh-CN": "https://zooi.ai/zh/" } as const;

/** The arrow after a primary action outside the shell, as on the website: lime on ink. */
export const AuthArrow = () => <ArrowRightIcon className="z-auth-arrow" size={16} weight="bold" aria-hidden />;

export function AuthFrame({ children }: { children: ReactNode }) {
  return <div className="z-auth">
    <header><a className="z-auth-mark" href={WEBSITE[locale()]}><Wordmark /></a></header>
    <main className="z-auth-card z-flow">{children}</main>
    <footer className="z-auth-foot"><LanguagePicker compact /></footer>
  </div>;
}
